import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { getAppConfig } from "@config/appConfig";
import { PLACEHOLDER_MOVIE_POSTER } from "@config/ImageSizes";
import toSeoUrl from "@functions/toSeoUrl";
import "./style.scss";

const MoviePoster = ({ movie, size, movieLink = true, showTitle = false }) => {
    const config = getAppConfig();

    const urlMovieImage = movie.movie_image;
    const fallbackImage = `${config?.cdnUrl}${PLACEHOLDER_MOVIE_POSTER}`;
    const imageUrl = urlMovieImage || fallbackImage;

    const onImageError = (e) => {
        e.target.src = fallbackImage;
    };

    const PosterImage = () => (
        <img
            loading="lazy"
            alt={`${movie.movie_title ? movie.movie_title : movie.title} poster image`}
            src={imageUrl}
            className="img movie-poster__img"
            onError={onImageError}
            title={movie.movie_title ? movie.movie_title : movie.title}
        />
    );

    return (
        <div className="movie-poster__container">
            <div className={`movie-poster movie-poster__${size}`}>
                {movieLink
                    ? (
                        <Link className="movie-poster__link" data-cy="movie-link" to={{ pathname: `/movie/${movie.movie_id}/${toSeoUrl(movie.movie_title)}` }}>
                            <PosterImage />
                        </Link>
                    ) : (
                        <PosterImage/>
                    )}
            </div>
            {showTitle && (
                <div className={`movie-poster__title movie-poster__title--${size}`}>
                    {movie.movie_title ? movie.movie_title : movie.title}
                </div>
            )}

        </div>
    );
};

MoviePoster.propTypes = {
    movie: PropTypes.shape({
        movie_image: PropTypes.string,
        movie_title: PropTypes.string,
        title: PropTypes.string,
        movie_id: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ])
    }),
    size: PropTypes.string,
    movieLink: PropTypes.bool,
    showTitle: PropTypes.bool
};

export default MoviePoster;
